<template>
  <div class="rb">
    <div class="bg1"></div>
    <div class="bg2"></div>
    <div class="textPosition">
      <div class="left-text">
        <div class="lt-1" :title="`${numformat(defaultdata[0].value2)}${defaultdata[0].value3}`">
          {{ numformat(defaultdata[0].value2) }}{{ defaultdata[0].value3 }}
        </div>
        <div class="hengg">
          <div class="hengg2" :style="{ width: (+defaultdata[0].value2 / total) * 100 + '%' }"></div>
        </div>
        <div class="lt-2 ellipsis" style="width: 79px" :title="defaultdata[0].value1">
          {{ defaultdata[0].value1 }}
        </div>
        <div class="lt-3">
          {{ ((+defaultdata[0].value2 / total) * 100).toFixed(2) }}%
        </div>
      </div>
      <div class="right-text">
        <div class="rt-1" :title="`${numformat(defaultdata[1].value2)}${defaultdata[1].value3}`">
          {{ numformat(defaultdata[1].value2) }}{{ defaultdata[1].value3 }}
        </div>
        <div class="henggr">
          <div class="henggr2" :style="{ width: (+defaultdata[1].value2 / total) * 100 + '%' }"></div>
        </div>
        <div class="rt-2 ellipsis" style="width: 79px" :title="defaultdata[1].value1">
          {{ defaultdata[1].value1 }}
        </div>
        <div class="rt-3">
          {{ ((+defaultdata[1].value2 / total) * 100).toFixed(2) }}%
        </div>
      </div>
    </div>
    <div ref="Rmain" class="Rmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
  </div>
</template>

<script>
import * as methods from "./method.js";

export default {
  name: "template.scope17",
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      defaultdata: [
        { value1: '系列一', value2: "662", value3: '单位' },
        { value1: '系列二', value2: "232", value3: '单位' },
      ],
      valueMap: [
        { name: '名称', key: 'value1' },
        { name: '数值', key: 'value2' },
        { name: '单位', key: 'value3' },
      ],
      exceldata: [],
      total: 0,
      timer: null,
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    TdrawLine() {
      clearInterval(this.timer)
      this.timer = null
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.Rmain);
      let chardata = this.defaultdata.map(item => {
        let newitem = {
          name: item.value1,
          value: item.value2
        }
        return newitem
      })
      var Toption = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          data: []
        },
        color: ["#0580ff", "#75fafd"],
        series: [
          {
            type: "pie",
            label: {
              normal: {
                color: "transparent",
                position: "outside",
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            radius: ["55%", "65%"],
            center: ["50%", "50%"],
            startAngle: 90,
            data: chardata
          }
        ]
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(function () {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n
        this.total = 0
        this.defaultdata.forEach(item => {
          this.total += +item.value2
        })
        this.TdrawLine()
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.TdrawLine()
    }
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.total = 0
    this.defaultdata.forEach(item => {
      this.total += +item.value2
    })
    this.TdrawLine()
  }
};
</script>

<style scoped>
.rb {
  width: 435px;
  height: 240px;
  padding: 10px 0;
  display: flex;
  position: relative;
}

.block {
  position: absolute;
  width: 140px;
  height: 40px;
  top: -40px;
  right: 80px;
}

.bg1 {
  width: 194px;
  height: 194px;
  box-sizing: border-box;
  background: url("@/assets/temimg2/right-bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: calc(50% - 97px);
  left: calc(50% - 97px);
  z-index: 1;
}

.bg2 {
  width: 55px;
  height: 44px;
  /* margin: 38px 0 0 40px; */
  position: absolute;
  top: calc(50% - 27.5px);
  left: calc(50% - 22px);
  box-sizing: border-box;
  background: url("@/assets/temimg2/right-center.png") no-repeat;
  background-size: 100%;
  z-index: 10;
}

.textPosition {
  width: 435px;
  height: 240px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 10px 0;
}

.left-text {
  width: 217.5px;
  height: 240px;
  position: absolute;
  top: 0;
  left: 0;
}

.hengg {
  width: 68px;
  height: 4px;
  background: #0c2f65;
  position: relative;
  margin: 16px 0 0 40px;
}

.hengg2 {
  width: 13px;
  height: 4px;
  background: #0d78fa;
  position: absolute;
  left: 0;
}

.lt-1 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  line-height: 17px;
  margin: 70px 0 0 40px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-2 {
  margin: 16px 0 0 40px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #0d78fa;
  line-height: 17px;
}

.lt-3 {
  margin: 16px 0 0 40px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 17px;
}

.right-text {
  width: 217.5px;
  height: 240px;
  /* background: lightblue; */
  position: absolute;
  top: 0;
  right: 0;
}

.henggr {
  width: 68px;
  height: 4px;
  background: #2e6970;
  position: relative;
  margin: 16px 0 0 130px;
}

.henggr2 {
  width: 13px;
  height: 4px;
  background: #75fafd;
  position: absolute;
  left: 0;
}

.rt-1 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  line-height: 17px;
  margin: 70px 0 0 130px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-2 {
  margin: 16px 0 0 130px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #75fafd;
  line-height: 17px;
}

.rt-3 {
  margin: 16px 0 0 130px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 17px;
}

.Rmain {
  width: 100%;
  height: 100%;
  z-index: 99;
}
</style>
